module.exports = __webpack_public_path__ + "static/media/hm.8bbb5756.svg";